const INITIAL_STATE = {
  list: [],
  opcoes: { equipes: [] },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'VIATURA_FETCHED':
      return { ...state, list: action.payload.data };
    case 'VIATURA_OPCOES_FETCHED':
      return { ...state, opcoes: action.payload };
    case 'VIATURA_PAGE':
      return { ...state, paginaAtual: action.payload };
    default:
      return state;
  }
};
